import script from "./ManualPaymentWriteOff.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualPaymentWriteOff.vue?vue&type=script&setup=true&lang=js"

import "./ManualPaymentWriteOff.vue?vue&type=style&index=0&id=59e2238f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e2238f"]])

export default __exports__